<template>
  <div>
    <builderall-banner
      :title='toolInfo.name'
      :subtitle='toolInfo.title'
      :description=' toolInfo.subtitle'
      tool="franchise-system"
    ></builderall-banner>

    <!-- Content -->
    <div class='ba-app-wrapper ba-gp-1'>
      <div class='ba-sidebar'>
        <ul class='ba-nav'>
          <li v-for="(r, i) in toolInfo.routes.menu" class='ba-nav-item'>
            <input v-if="r.is_submenu" type="checkbox" :checked="r.status_collapse || r.route.route_name == toolInfo.current_route && isNotSubMenu(r)" class="ba-nav-item-input-status">
            <label v-if="r.is_submenu" class='ba-nav-item-expandable'>
              <div class="ba-nav-item-expandable-content" @click="expandCollapse(i)">
                <builderall-icon :code="IsNotEmpty(r.icon_from_builderall_css) ? r.icon_from_builderall_css : '8236'" />
                <span class='ba-title'>{{ r.titulo }}</span>
                <builderall-icon code='5da4' class='ba-link-expandable-icon' />
              </div>
              <ul class="ba-nav-subitems">
                <hr class="ba-hr-row">
                <li v-for="(subMenu, index) in r.menu" :key="index"
                    class="ba-nav-subitem"
                >
                  <a :href="IsNotEmpty(subMenu.route.link) ? subMenu.route.link : subMenu.route.name"
                     class="ba-nav-subitem-link"
                     :target='subMenu.route.target'
                  >
                    <span class="ba-title">{{ subMenu.titulo }}</span>
                  </a>
                </li>
              </ul>
            </label>
            <a v-else
               :href='r.route.name'
               :class="['ba-link',
                 r.route.route_name == toolInfo.current_route
                 && !r.is_modal
                 ? 'ba-is-active' : '']"
            >
              <builderall-icon :code="IsNotEmpty(r.icon_from_builderall_css) ? r.icon_from_builderall_css : '8236'" />
              <span class='ba-title'>{{ r.titulo }}</span>
            </a>
          </li>
        </ul>
        <div class='ba-bottom'>
          <ul class='ba-bottom-list'>
            <li>
              <builderall-help></builderall-help>
            </li>
          </ul>
        </div>
      </div>
      <div class='ba-container ba-flex ba-gp-1 ba-ai-baseline ba-jc-center ba-f-wrap'>
        <div class='m-h ba-w-100'>
          <slot />
        </div>
      </div>
      <div class='ba-footer'>
        <builderall-footer></builderall-footer>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "franchise-layout",
  props: {
    view: {
      type: [Array, Object],
      required: false
    }
  },
  data() {
    return {
      toolInfo: {
        name: 'tool name',
        title: 'Title',
        subtitle: 'Subtitle',
        banner: '',
        icon: ''
      }
    }
  },
  created() {
    this.toolInfo = this.view
  },
  methods: {
    expandCollapse(index) {
      this.toolInfo.routes.menu[index].status_collapse =! this.toolInfo.routes.menu[index].status_collapse
    },
    IsNotEmpty(val) {
      return !isEmpty(val);
    },
    isNotSubMenu(val) {
      let isModal = false

      for (let i in val.menu) {
        isModal = !isModal && val.menu[i].is_modal ? true : false
      }

      return isModal
    }
  }
}
</script>
<style>
.ba-app-content, #wrapper {
  height: auto !important;
  max-height: calc(100% - 80px);
}
.ba-app-content {
  overflow-y: hidden !important;
}
#wrapper {
  overflow-y: scroll !important;
}
.banner {
  position: absolute;
  width: 100%;
  height: 256px;
  margin: -1.8rem;
}
.m-h {
  min-height: 35rem;
}
.route-icon {
  width: 25px;
  height: 25px;
}
.d-none {
  display: none !important;
}
* {
  font-family: Montserrat;
}
@media (max-width: 1430px) {
  .m-h{
    width: calc(100vw - 32px - 228px - 54px);
  }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/layouts/FranchiseLayout.vue